const isListUndefined = list => list[0] === 'USP Undefined'

export const getUsp = ({ productDetails }) => {
  const { uspData, onlineUspData } = productDetails

  if (onlineUspData) {
    return isListUndefined(onlineUspData) ? false : onlineUspData
  }

  if (!uspData) {
    return false
  }

  return isListUndefined(uspData) ? false : uspData
}
